import { ToEntity } from 'core/common/mappers';
import { Payment } from '../entities';
import { PaymentDto } from '../services/dto';

export class PaymentDtoMapper implements ToEntity<Payment, PaymentDto> {
  toEntity(dto: PaymentDto): Payment {
    return {
      status: dto.payment_status,
    };
  }
}
